import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Switch from '@material-ui/core/Switch';
import { Field, useFormikContext } from 'formik';
import React, { memo, useEffect } from 'react';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';

import type { IAffiliate } from 'v2/interfaces/affiliate';

import styles from '../styles';

import type { IFormCommision } from '../interfaces';

interface IProps {
  handleClose: Function;
  affiliate: IAffiliate;
}

const FormCommision = ({ handleClose, affiliate }: IProps) => {
  const classes = styles({});

  const { values, setFieldValue, isSubmitting, isValid } = useFormikContext<IFormCommision>();

  const onChangeActive = (_: React.ChangeEvent<{}>, checked: boolean) => {
    setFieldValue('active', checked);
  };

  const onChangeType = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue('type', e.target.value);
    setFieldValue('value', '');
  };

  const typeOptions = [
    {
      label: 'Porcentagem',
      value: 'P',
    },
    {
      label: 'Valor',
      value: 'V',
    },
  ];

  useEffect(() => {
    if (affiliate.custom_commission_type && affiliate.custom_commission) {
      setFieldValue('active', true);
    }

    if (affiliate.custom_commission_type) {
      setFieldValue('type', affiliate.custom_commission_type);
    }

    if (affiliate.custom_commission) {
      setFieldValue('value', affiliate.custom_commission);
    }
  }, [affiliate, setFieldValue]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item sm={12}>
          <FormControlLabel
            label='Habilitar comissão diferenciada'
            control={<Switch color='default' checked={values.active} disabled={isSubmitting} />}
            onChange={onChangeActive}
          />
        </Grid>

        <Grid item xs={12} md={7}>
          <Field
            id='type'
            name='type'
            label='Tipo da comissão'
            fullWidth
            disabled={values.type === 'P'}
            options={typeOptions}
            component={SelectFormField}
            onChange={onChangeType}
          />
        </Grid>

        <Grid item xs={12} md={5}>
          {values.type === 'P' && (
            <Field id='value' disabled={!values.active} name='value' label='Porcentagem' mask='percent' fullWidth component={TextFormField} />
          )}

          {values.type === 'V' && (
            <Field id='value' disabled={!values.active} name='value' mask='money' label='Valor' fullWidth component={TextFormField} />
          )}
        </Grid>
      </Grid>

      <div className='m16' />

      <Grid container spacing={1}>
        <Grid item xs={12} className={classes.buttonWrapper}>
          <Button color='default' disabled={isSubmitting} onClick={() => handleClose()}>
            Fechar
          </Button>

          <Button color='primary' variant='contained' disabled={isSubmitting || !isValid} type='submit'>
            Salvar
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default memo(FormCommision);
